import { ANALYTICS_DASHBOARDS_NATIVE } from '@shared/constants/flags';

export const routes = [
  {
    path: '/analytics',
    name: 'analyticsHome',
    component: () => import('../pages/AnalyticsPage.vue'),
    meta: {
      newAppPath: '/analytics-dashboards',
      newAppFlag: ANALYTICS_DASHBOARDS_NATIVE,
    },
  },
];
